import React, { useState } from 'react';
import plainApi from '../utils/plainApi';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await plainApi.post('/auth/login.php', { email, password });
      const data = response.data;

      if (data.success) {
        localStorage.setItem('token', data.token);
        if (data.user) localStorage.setItem('user', JSON.stringify(data.user));
        // Full page reload to ensure auth context picks up the token
        window.location.href = '/dashboard';
      } else {
        setError(data.error || 'Invalid email or password');
        setLoading(false);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Attorney Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {error && (
          <div className="modern-error">
            <span className="error-text">{error}</span>
          </div>
        )}

        <p className="demo-note">Demo: demo@example.com / password123</p>
      </div>
    </div>
  );
};

export default LoginPage;